module.exports = __webpack_public_path__ + "img/slide1.bfe52fce.png";